import Ribbon from 'antd/lib/badge/Ribbon';
import { withConfigProvider } from '../config-provider';
export default withConfigProvider(Ribbon);
